import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {IrbSettingsService} from '@irb/irb-settings/irb-settings.service';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-altIf-held-checkbox-cell',
    template: `<p-checkbox binary="true" [(ngModel)]="params.data.altIfHeldFlag" [disabled]="isDisabled()"
                           (onChange)="onChange($event)"></p-checkbox>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class altIfHeldCheckboxCellRenderer implements AgRendererComponent {

    params: any;

    constructor(public iss: IrbSettingsService) {
    }

    agInit(params: any) {
        this.params = params;

    }

    refresh(): boolean {
        return false;
    }

    isDisabled() {
        return (this.params.data && this.params.data.eqSecurityType === "CustCat");
    }

    onChange(event: any) {
        this.params.data.altIfHeldFlag = event.checked;
        this.params.context.componentParent.onAltIfHeldCheckboxChanged(this.params.data, event.checked, this.params.node.rowIndex);
    }
}
